import { Reveal } from "./Reveal";

const Attorney = () => (
    <section id="attorney" className="bg-white py-24 lg:py-32">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
            <div className="grid lg:grid-cols-5 gap-14 lg:gap-20 items-start">
                <Reveal className="lg:col-span-2">
                    <figure>
                        <div className="border border-[#E5D7B5] p-3 bg-[#FAF6EE]">
                            <div className="border border-[#B89047]/50 p-1.5">
                                <img
                                    data-testid="attorney-portrait-image"
                                    src="https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxhdHRvcm5leSUyMHBvcnRyYWl0JTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MDIxNjM4OHww&ixlib=rb-4.1.0&q=85"
                                    alt="Dan Rosengarten — Attorney at Law (placeholder portrait)"
                                    className="w-full aspect-[4/5] object-cover"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        <figcaption className="mt-4 text-center font-mono-label text-[10px] tracking-[0.2em] uppercase text-slate-400">
                            Placeholder portrait — professional photograph to be provided
                        </figcaption>
                    </figure>
                </Reveal>

                <div className="lg:col-span-3">
                    <Reveal>
                        <p className="font-mono-label text-[11px] tracking-[0.3em] uppercase text-[#8E6C2D] mb-5">
                            Attorney Profile
                        </p>
                        <h2 className="font-serif-display text-3xl lg:text-4xl font-medium tracking-tight text-[#0B192C] leading-[1.2]">
                            Dan Rosengarten
                        </h2>
                        <p className="mt-2 font-serif-display italic text-lg text-slate-500">
                            Attorney at Law
                        </p>
                    </Reveal>

                    <Reveal delay={0.1}>
                        <p className="mt-7 text-base text-slate-600 leading-relaxed">
                            Dan Rosengarten is the attorney behind Dan Rosengarten Law Firm, a
                            South African legal practice offering professional representation with
                            personal attention. He works directly with clients to understand their
                            individual legal needs and to guide them through each stage of their
                            matter.
                        </p>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);

export default Attorney;
